export function entries(object) {
    return Object.entries(object);
}
